<template>
	<div class="container">
    <img :src="showImage(form.certImage)" width="100%">

    <span class="txt cert-no" :style="{top: form.certNoTop + 'px', left: form.certNoLeft+'px'}">{{form.courseCode}}</span>
    <span class="txt eng-name" :style="{top: form.enNameTop + 'px', left: form.enNameLeft+'px'}">{{form.studentEnName}}</span>
    <span class="txt cht-name" :style="{top: form.chNameTop + 'px', left: form.chNameLeft+'px'}">{{form.studentChName}}</span>

    <!-- <div class="home" :style="{backgroundImage: 'url(' + showImage(form.certImage) + ')' }">
      <span class="txt cert-no" :style="{top: form.certNoTop + 'px', left: form.certNoLeft+'px'}">{{form.courseCode}}</span>
      <span class="txt eng-name" :style="{top: form.enNameTop + 'px', left: form.enNameLeft+'px'}">{{form.studentEnName}}</span>
      <span class="txt cht-name" :style="{top: form.chNameTop + 'px', left: form.chNameLeft+'px'}">{{form.studentChName}}</span>
    </div> -->
  </div>
</template>

<script>
	export default {
		name:'CertPrintContent',
    props: {
      form: Object
    }
	}	
</script>



<style scoped>
.txt {
  color: black;
  font-weight: bold;
  font-size: 12px;
}
.cert-no{
  position: absolute;
 /* top: 112px;
  left: 610px;*/
}
.eng-name {
  position: absolute;
  /*top: 252px;
  left: 370px;*/
}
.cht-name {
  position: absolute;
 /* top: 293px;
  left: 158px;*/
}

.container {
  text-align: center;
  width: 860px;
/*  max-width: 100%;*/
  height: 100vh;
  padding: 20px 20px 0;
  z-index: 2;
  position: absolute;
  background-color: greenyellow;
}
.home {
/*  background: url('~@/assets/basic-min.jpg');*/
  background-repeat: no-repeat;
  background-size: contain;
  width: 960px;
/*  max-width: 100%;*/
  height: 100vh;
}
</style>





